import { useQuery } from '@tanstack/react-query';
import { fetchPlaceByName } from '@/lib/fetchPlaceDetail';
import { queryClient } from '@/lib/queryClient';
import type { PlaceData } from '@/types/placeDetail';

export const placeDetailQueryKey = (decodedName: string) =>
  ['placeDetail', decodedName] as const;

const STALE_MS = 5 * 60_000;

export function usePlaceDetailQuery(placeNameEncoded: string | undefined) {
  const decoded = placeNameEncoded
    ? decodeURIComponent(placeNameEncoded)
    : '';

  return useQuery<PlaceData, Error>({
    queryKey: placeDetailQueryKey(decoded),
    queryFn: () => fetchPlaceByName(decoded),
    enabled: !!decoded,
    staleTime: STALE_MS,
    gcTime: 30 * 60_000,
  });
}

/** Prefetch before navigation or on link hover (use raw DB place name, not URL-encoded). */
export function prefetchPlaceDetail(rawPlaceName: string) {
  const name = rawPlaceName?.trim();
  if (!name) return;
  void queryClient.prefetchQuery({
    queryKey: placeDetailQueryKey(name),
    queryFn: () => fetchPlaceByName(name),
    staleTime: STALE_MS,
  });
}
